import React from 'react'

interface DocFooterProps {
  names: {
    profileName: string
    organizationName: string
    clientName: string
  }
}

import { useFeatureFlag } from '../hooks/useFeatureFlag'

import DocFooterV2 from './DocFooterV2'

const DocFooter: React.FC<DocFooterProps> = ({ names }) => {
  const { useNewDocumentUI } = useFeatureFlag()

  if (useNewDocumentUI) return <DocFooterV2 names={names} />

  return (
    <div className="flex justify-center space-x-14 mt-20">
      {/* First Column */}
      <div className="text-center">
        <hr className="border-gray-400  w-48 mx-auto mb-2" />
        <p className="font-semibold">{names.organizationName}</p>
      </div>

      {/* Second Column */}
      <div className="text-center">
        <hr className="border-gray-400 w-48 mx-auto mb-2" />
        <div className="flex flex-col items-center">
          <p className="font-semibold">{names.profileName}</p>
          <p>{names.organizationName}</p>
        </div>
      </div>

      {/* Third Column */}
      <div className="text-center">
        <hr className="border-gray-400  w-48 mx-auto mb-2" />
        <p className="font-semibold">{names.clientName}</p>
      </div>
    </div>
  )
}

export default DocFooter
